import type { VercelDeployResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import type { VercelDeployOptions } from '@cli-types/next-adapter/vercel.js'
import { DETAIL_MAX_LINES } from '@cli-constants/process-output.js'
import { DEPLOY_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { outputTail } from '@cli-utils/process.js'
import { runVercel } from '../runner/run-vercel.js'
import { parseDeployedUrl } from './parse-deployed-url.js'

export async function deployVercelProject(
  runner: VercelRunner,
  cwd: string,
  options: VercelDeployOptions = {}
): Promise<VercelDeployResult> {
  const deploy = await runVercel(runner, ['deploy', '--prod', '--yes'], {
    cwd,
    mode: 'capture',
    timeoutMs: DEPLOY_TIMEOUT_MS,
    env: options.env,
    onOutputLine: options.onLogLine
  })

  if (deploy.success) {
    return { url: parseDeployedUrl(deploy.stdout, deploy.stderr) }
  }

  return {
    failure: deploy.timedOut ? 'timeout' : 'deploy-failed',
    detail: outputTail(`${deploy.stdout}\n${deploy.stderr}`, DETAIL_MAX_LINES)
  }
}
